import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AuthHeader from '../components/AuthHeader'

const PrivacyPolicyPage = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-black">
      <div className='p-4'>
        <div className="border-2 border-white">
          <AuthHeader />
          <div className='bg-[#141414] p-4 w-full min-h-screen'>
            <div className="w-full max-w-4xl mx-auto py-8 px-4">
              <div className="bg-card border border-gray-700 p-6 md:p-8">
                {/* Back Button */}
                <button
                  onClick={() => navigate(-1)}
                  className="mb-6 flex items-center gap-2 text-gray-400 hover:text-white transition-colors font-avenir text-sm"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Back
                </button>

                <h1 className="text-3xl md:text-4xl font-bold text-white mb-2 font-avenir tracking-wider">
                  Privacy Policy
                </h1>
                <p className="text-gray-400 text-sm mb-8 font-avenir">
                  TLP Network Inc. (The Launch Pad)
                </p>
                <p className="text-gray-400 text-sm mb-8 font-avenir">
                  Effective Date: January 2026
                </p>

                <div className="prose prose-invert max-w-none text-white space-y-6 font-avenir">
                  <p className="text-gray-300 leading-relaxed">
                    TLP Network Inc. ("TLP," "The Launch Pad," "we," "us," or "our") respects your privacy. This Privacy Policy explains how we collect, use, store, and protect information when you use our websites, platforms, and services (collectively, the "Services").
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    By using our Services, you agree to this Privacy Policy.
                  </p>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">1. Information We Collect</h2>
                    
                    <h3 className="text-xl font-semibold text-white mt-6 mb-3 font-avenir">a) Information You Provide</h3>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>Name, email address, and contact details</li>
                      <li>Messages, comments, or submissions</li>
                      <li>Information provided through forms, newsletters, donations, or purchases</li>
                    </ul>

                    <h3 className="text-xl font-semibold text-white mt-6 mb-3 font-avenir">b) Automatically Collected Information</h3>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>IP address, browser type, device information</li>
                      <li>Pages visited, referring URLs, timestamps</li>
                      <li>Cookies and similar tracking technologies</li>
                    </ul>

                    <h3 className="text-xl font-semibold text-white mt-6 mb-3 font-avenir">c) Third-Party Information</h3>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>Analytics and advertising data from platforms such as Google, Meta, X, or YouTube</li>
                      <li>Payment information processed securely by third-party providers (we do not store full payment details)</li>
                    </ul>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">2. How We Use Your Information</h2>
                    <p className="text-gray-300 leading-relaxed mb-3">We use information to:</p>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>Operate, maintain, and improve our Services</li>
                      <li>Communicate updates and announcements</li>
                      <li>Process transactions and donations</li>
                      <li>Analyze usage and audience engagement</li>
                      <li>Ensure security and prevent fraud</li>
                      <li>Comply with legal obligations</li>
                    </ul>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">3. Cookies & Tracking Technologies</h2>
                    <p className="text-gray-300 leading-relaxed">
                      We use cookies to improve functionality, analytics, and performance. You may disable cookies via your browser settings, though some features may not function correctly.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">4. Sharing of Information</h2>
                    <p className="text-gray-300 leading-relaxed mb-3">
                      We do not sell personal information.
                    </p>
                    <p className="text-gray-300 leading-relaxed mb-3">Information may be shared with:</p>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>Service providers (hosting, analytics, payments)</li>
                      <li>Advertising and analytics partners</li>
                      <li>Legal authorities when required by law</li>
                      <li>Business successors in the event of a merger or acquisition</li>
                    </ul>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">5. Data Security</h2>
                    <p className="text-gray-300 leading-relaxed">
                      We use reasonable safeguards to protect your information. However, no system is completely secure, and we cannot guarantee absolute security.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">6. International Users</h2>
                    <p className="text-gray-300 leading-relaxed">
                      TLP is based in Canada. By using our Services, you consent to the processing and storage of your information in Canada or other jurisdictions.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">7. Children's Privacy</h2>
                    <p className="text-gray-300 leading-relaxed">
                      Our Services are not directed to children under 13. We do not knowingly collect personal information from children.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">8. Your Rights</h2>
                    <p className="text-gray-300 leading-relaxed">
                      Depending on your location, you may have rights to access, correct, or delete your personal data or withdraw consent.
                    </p>
                    <p className="text-gray-300 leading-relaxed mt-3">
                      Requests can be sent to <a href="mailto:contact@tlpnetwork.com" className="text-red-400 hover:text-red-300 transition-colors">contact@tlpnetwork.com</a>.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">9. Changes to This Policy</h2>
                    <p className="text-gray-300 leading-relaxed">
                      We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">10. Contact Us</h2>
                    <p className="text-gray-300 leading-relaxed mb-2">TLP Network Inc.</p>
                    <p className="text-gray-300 leading-relaxed">
                      Email: <a href="mailto:contact@tlpnetwork.com" className="text-red-400 hover:text-red-300 transition-colors">contact@tlpnetwork.com</a>
                    </p>
                  </section>
                </div>

                {/* Footer Links */}
                <div className="mt-12 pt-6 border-t border-gray-700 flex flex-wrap justify-center gap-4 text-sm">
                  <Link
                    to="/terms-of-use"
                    className="text-gray-400 hover:text-red-300 transition-colors font-avenir"
                  >
                    Terms of Use
                  </Link>
                  <span className="text-gray-600">|</span>
                  <Link
                    to="/login"
                    className="text-gray-400 hover:text-red-300 transition-colors font-avenir"
                  >
                    Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
